import React, { useEffect } from 'react';
import { MytaverseEventProvider } from '@core/dashboard/providers';
import { useCheckUniqueApplicationAccessPerAccount } from '../hooks/permissions';
import { useInitPrivateRoutesState } from './hooks';
import VideoGamecast from '../components/VideoGameCast';
import { useMytaverse } from '../providers/MytaverseProvider';
import { LeaveEventReason } from '../providers/MytaverseProvider/interfaces';
import ExternalEventPageContent from '@core/event/pages/ExternalEventPage/ExternalEventPageContent';
import { useLocation } from 'react-router-dom';
import UnfinishedAvatarModal from '@core/avatar/components/UnfinishedAvatarModal';
import EventFullLoadingPage from '@core/event/pages/EventFullLoadingPage';
import { MytaverseLogger } from '@helpers/logger';

const EventPageContainer: React.FC = () => {
  const hasMultipleConnections = useCheckUniqueApplicationAccessPerAccount();
  const initializing = useInitPrivateRoutesState();
  const [teleportButtonClicked, setTeleportButtonClicked] =
    React.useState(false);
  const { navigateToEventsPage } = useMytaverse();
  const { state } = useLocation();

  useEffect(() => {
    if (hasMultipleConnections) {
      MytaverseLogger.log('Uniqueness guard redirect to /events');
      navigateToEventsPage({
        reason: LeaveEventReason.UniquenessGuardEvicted,
        message: 'notifications.duplicateGamecastSession',
      });
    }
  }, [hasMultipleConnections, navigateToEventsPage]);

  if (initializing) {
    return <EventFullLoadingPage />;
  }

  if (hasMultipleConnections) {
    // this doesn't really matter as we redirect to events page
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (!teleportButtonClicked && state?.isExternalEvent) {
    return (
      <ExternalEventPageContent
        setTeleportButtonClicked={setTeleportButtonClicked}
      />
    );
  }

  return (
    <>
      <MytaverseEventProvider />
      <VideoGamecast />
      <UnfinishedAvatarModal />
    </>
  );
};

export default EventPageContainer;
